// extracted by mini-css-extract-plugin
module.exports = {"Thumb":"ChapterPlayer_Thumb__WGZf_","ThumbZoom":"ChapterPlayer_ThumbZoom__3LokF"};